import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=1d584706"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"
import style0 from "./Formulario.vue?vue&type=style&index=0&id=1d584706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports